module.exports = __webpack_public_path__ + "img/ki.81fec63e.svg";